module.exports = __webpack_public_path__ + "static/media/19ESCAP44.275612ad.jpg";